import { Address } from "~/interfaces/entities/Address"

export const getAddressLines = (address: Address) => {
  const { line1, line2 } = address
  const addressLine = line2 ? `${line1}, ${line2}` : line1
  return addressLine
}
